import type { Modifier, Placement } from '@popperjs/core';

/**
 * Calculate the tooltip offset based on the current
 * placement value
 */
export function getTooltipOffset(placement: Placement): [number, number] {
  const TOOLTIP_ARROW_SIZE = 6;
  if (/top|bottom|left|right|start|end/.test(placement)) {
    return [0, TOOLTIP_ARROW_SIZE];
  } else {
    return [TOOLTIP_ARROW_SIZE, TOOLTIP_ARROW_SIZE];
  }
}

/**
 * Calculate the possible max size to make sure that the tooltip
 * is always fully visible in the viewport
 */
export const applyMaxSizeModifier: Modifier<'applyMaxSize', Record<string, unknown>> = {
  name: 'applyMaxSize',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['maxSize'],
  fn({ state }) {
    const { width, height } = state.modifiersData.maxSize as { width: number; height: number };

    state.styles.popper = {
      ...state.styles.popper,
      maxWidth: `${width}px`,
      maxHeight: `${height}px`,
    };
  },
};

/**
 * Verify that elementA and elementB are intersecting each other
 * by checking if elementA is the same as elementB
 * or if elementA contains elementB
 */
export function areElementsIntersecting(elementA: Element | null, elementB: EventTarget | null) {
  if (isElement(elementA) && isElement(elementB)) {
    return elementA?.contains(elementB as Element);
  }
  return false;
}

/**
 * Check if a value is a valid HTMLElement
 */
function isElement(el: EventTarget | null) {
  // We have to specifically check Element and not just HTMLElement
  // because HTMLElement does not include XML elements like SVGs
  return el instanceof Element;
}
